import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  position: relative;
  left: -2px;

  .__react_component_tooltip {
    ${mediaMaxWidth.phone`
      display: none;
    `}
  }
`;

export const Input = styled.input`
  z-index: 1;
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  cursor: pointer;
  outline: 2px solid transparent;
  position: absolute;
  margin-top: 13.5px;
  outline-offset: 14.5px;
  margin-left: 14px;
  -webkit-transition: 0.1s ease-in-out;
  transition: 0.1s ease-in-out;
  width: 12px;
  height: 12px;
  transition: 0.1s ease-in-out;

  &:checked + label:before {
    background-color: ${(props) => (props.disabled ? "#ababab" : "#402680")};
    border: ${(props) =>
      props.disabled ? "2px solid #ababab" : "2px solid #402680"};
  }

  &:checked + label:after {
    content: "";
    display: block;
    position: absolute;
    top: 2px;
    left: 14px;
    width: 10px;
    height: 24px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    z-index: 3;
  }

  &:focus {
    outline: ${(props) =>
      props.isError ? "2px solid transparent" : "2px solid #8064d4"};
  }
`;

export const Label = styled.label`
  position: relative;
  cursor: pointer;
  height: 40px;
  display: flex;
  color: ${(props) => (props.isError ? "#888" : "#402680")};
  align-items: center;
  font-size: 0.9em;
  line-height: 1.4em;

  &:before {
    content: "";
    -webkit-appearance: none;
    background-color: #fff;
    border: ${(props) =>
      props.isError ? "2px solid #79D9D9" : "2px solid #fff"};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
      inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
    padding: 18px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    cursor: pointer;
    margin-right: 20px;
    z-index: 2;
  }
`;

export const LabelText = styled.span`
  color: ${(props) => props.disabled && "#888"};
`;

export const LabelLink = styled.a`
  color: ${(props) =>
    props.isError ? "#888 !important" : "#402680 !important"};
  color: ${(props) => props.disabled && "#888"};
  transition: 0.1s ease-in-out;

  &:focus {
    outline: 2px solid #8064d4;
  }
`;

export const ModalTrigger = styled.a`
  color: ${(props) =>
    props.isError ? "#888 !important" : "#402680 !important"};
  color: ${(props) => props.disabled && "#888 !important"};
  transition: 0.1s ease-in-out;

  &:focus {
    outline: 2px solid #8064d4;
  }
`;

export const Error = styled.div`
  position: absolute;
  bottom: -18px;
  width: 100%;
  text-align: center;
  font-size: 0.82em;
  font-weight: 600;
  color: #79D9D9;
`;
